import { render, staticRenderFns } from "./ThreadsShow.vue?vue&type=template&id=32af2491"
import script from "./ThreadsShow.vue?vue&type=script&lang=js"
export * from "./ThreadsShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports